import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import type { FC } from "react";
import React from "react";
import { twMerge } from "tailwind-merge";

const calloutClass = cva("border-2 rounded-lg text-xs mt-2 relative", {
  variants: {
    color: {
      blue: "border-blue-3 text-blue-3",
      red: "border-red-3 text-red-3",
      secondary: "border-glyph-scd text-glyph-prm",
    },
  },
  defaultVariants: {
    color: "blue",
  },
});

const calloutContentClass = cva("", {
  variants: {
    size: {
      medium: "m-2",
    },
  },
  defaultVariants: {
    size: "medium",
  },
});

const calloutBgClass = cva("opacity-10 absolute w-full h-full", {
  variants: {
    color: {
      blue: "bg-blue-3",
      red: "bg-red-3",
      secondary: "bg-glyph-scd",
    },
  },
  defaultVariants: {
    color: "blue",
  },
});

type CalloutProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof calloutClass> &
  VariantProps<typeof calloutContentClass>;

const Callout: FC<CalloutProps> = ({ color, size, children, className, ...otherProps }) => {
  return (
    <div className={twMerge(calloutClass({ color }), className)} {...otherProps}>
      <div className={calloutBgClass({ color })} />
      <div className={twMerge(calloutContentClass({ size }))}>{children}</div>
    </div>
  );
};

export default Callout;
